import React from 'react';

import fromAnyToBool from 'utils/converters/fromAnyToBool.util';

const GeneralTitle = ({ generalTitle, subTitle }) => (
  <div data-bem="GeneralTitle">
    <h2 className="general-title-settings"> {generalTitle}</h2>
    {fromAnyToBool(subTitle) && <p className="sub-title"> {subTitle}</p>}
  </div>
);

export default GeneralTitle;
